import React from 'react'
import getStartedData from '../../../../constants/GetStartedData'
import CodeBlock from '../../../../shared/CodeBlock/CodeBlock'
import config from '../../../../config'

const PDEX_URL= config.pdex_implementation_guide;
const SMART_URL=config.smart_implementation_guide;

function SupportedDataAccess({ stepNumber, patientAccess = false, pdex = false, sandbox = false, accessType }) {
    const data = getStartedData[accessType]
    return (
        <div className="step-container">
            <div className="number-and-title">
                <h2 className="step-number">{stepNumber}</h2>
                <h2 className="step-title">Supported Data Access Mechanism</h2>
            </div>
            <ul className='step-content'>
                {
                    data.description &&
                    <p dangerouslySetInnerHTML={{ __html: data.description }} />
                }
                {
                    data.patientAccessEndpoints && (
                        <div className="endpoint-container">
                            <h3>{`${stepNumber}.1`} Patient Access API Endpoints</h3>
                            <p>Leverage the OAuth/token and FHIR endpoints to access FHIR data in accordance with the <a href={`${SMART_URL}`} target="_blank">SMART Implementation guide.</a> This is particularly relevant for Payer-member and Third-party applications.</p>
                            {/* <h4>base_url: <code>{data.base_url}</code></h4> */}
                            {
                                data.patientAccessEndpoints?.map(endpoint => {
                                    return (
                                        <div className="endpoint" key={endpoint.request.path}>
                                            {endpoint.endpointStep.map(eachendpointstep => {
                                                return (eachendpointstep && <p className="endpoint-step" dangerouslySetInnerHTML={{ __html: eachendpointstep }} />)
                                            })
                                            }
                                            {
                                                endpoint.endpointName &&
                                                <CodeBlock
                                                    title="Sample Request"
                                                    requestType={endpoint.request.action}
                                                    content={endpoint.request}
                                                    endpointName={endpoint.endpointName}
                                                />
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                    )
                }
                {
                    data.pdexAccessEndpoints && (
                        <div className="endpoint-container">
                            <h3>{`${stepNumber}.${data.patientAccessEndpoints ? 2 : 1}`} Pdex Access API Endpoints</h3>
                            <p>
                                Use the token, member match and FHIR data endpoints to get access tokens, perform member match operation and retrieve data. Specifically applicable to {accessType + "s"} who have implemented the <a href={`${PDEX_URL}`} target="_blank" >Pdex Implementation guide</a>.
                            </p>
                            {/* <h4>base_url: <code>{data.base_url}</code></h4> */}
                            {
                                data.pdexAccessEndpoints?.map(endpoint => {
                                    return (
                                        <div className="endpoint" key={endpoint.request.path}>
                                            {endpoint.endpointStep.map(eachendpointstep => {
                                                return (eachendpointstep && <p className="endpoint-step" dangerouslySetInnerHTML={{ __html: eachendpointstep }} />)
                                            })
                                            }
                                            {
                                                endpoint.endpointName &&
                                                <CodeBlock
                                                    title="Sample Request"
                                                    requestType={endpoint.request.action}
                                                    content={endpoint.request}
                                                    endpointName={endpoint.endpointName}
                                                />
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                    )
                }
            </ul>
        </div>
    )
}

export default SupportedDataAccess